require('angular').module('wowApp.common')
    .factory('config', ['BootstrapService', require('./config-factory')]);



// WEBPACK FOOTER //
// ./src/common/config/index.js